import React, { ReactNode, useState } from 'react'
import { MenuItem, Dropdown } from 'react-bootstrap'

import i18n from 'live/services/i18n'

import { DropDownGalleryContainer } from './styles'

interface MenuItemGalleryProps {
    itemProps: MenuItem.MenuItemProps
}

interface DropDownGalleryProps {
    id?: string
    title: string
    children: ReactNode
}

export function DropDownGallery({ id, title, children }: DropDownGalleryProps): JSX.Element {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <DropDownGalleryContainer>
            <Dropdown id="" pullRight onToggle={isOpen => setIsOpen(isOpen)}>
                <Dropdown.Toggle noCaret>
                    <i className="far fa-ellipsis-v ellipsisGallery" />
                    {title}
                </Dropdown.Toggle>
                <Dropdown.Menu>{children}</Dropdown.Menu>
            </Dropdown>
        </DropDownGalleryContainer>
    )
}
